import React from 'react';
import { Select } from 'antd';
import { shutdownTypesQuery } from '../../../../../../shared/api/queries';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { getValidationRules } from './utils';
import {
  useSetSelectValueSubscription,
  valueTypes,
} from '../../../lib/subscriptions';

const { useShutdownTypes } = shutdownTypesQuery;
const { Option } = Select;
const fieldName = fieldNames.type;

const TypeField = ({ form, initialValue, editMode }) => {
  const { data, isFetching } = useShutdownTypes({ staleTime: Infinity });

  useSetSelectValueSubscription({
    fieldName,
    data,
    valueType: valueTypes.number,
    form,
  });

  return (
    <Field
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Тип"
      decoratorOptions={{
        rules: getValidationRules({ initialValue, editMode }),
        initialValue: data?.length ? initialValue : undefined,
      }}
      fieldProps={{
        placeholder: 'Выберите тип',
        loading: isFetching,
      }}
      items={data}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
        >
          {item.name}
        </Option>
      )}
    />
  );
};

export default TypeField;
